var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/require-default-props */
import React, { forwardRef, useRef } from 'react';
import './ToggleStyles.scss';
/**
 * Toggle Component
 * @version 1.0.0
 * @since 2026-01-27
 */
export const Toggle = forwardRef((_a, ref) => {
    var { checked, onChange, className = '', disabled = false, label, labelPosition = 'right', helperText } = _a, props = __rest(_a, ["checked", "onChange", "className", "disabled", "label", "labelPosition", "helperText"]);
    // React 17-compatible stable ID using useRef with lazy initialization
    const generatedIdRef = useRef();
    if (!generatedIdRef.current) {
        generatedIdRef.current = `toggle-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    }
    const inputId = props.id || generatedIdRef.current;
    const labelTextId = `${inputId}-label`;
    const toggleClass = `qmb-ui-toggle ${className}`;
    const hasLabel = Boolean(label);
    const wrapperClass = hasLabel ? 'qmb-ui-toggle-wrapper' : '';
    const positionClass = hasLabel ? `qmb-ui-toggle-wrapper--${labelPosition}` : '';
    const toggleElement = (React.createElement(React.Fragment, null,
        React.createElement("input", Object.assign({ ref: ref, type: "checkbox", className: "qmb-ui-toggle__input", checked: checked, onChange: onChange, disabled: disabled, id: inputId, "aria-labelledby": hasLabel ? labelTextId : undefined, "aria-label": !hasLabel ? props['aria-label'] : undefined }, props)),
        React.createElement("label", { htmlFor: inputId, className: `${toggleClass} ${disabled ? 'qmb-ui-toggle--disabled' : ''}` },
            React.createElement("span", { className: "qmb-ui-toggle__slider" }))));
    if (!hasLabel) {
        return React.createElement("div", { className: "qmb-ui-toggle-standalone" }, toggleElement);
    }
    return (React.createElement("div", { className: `${wrapperClass} ${positionClass}` },
        toggleElement,
        React.createElement("div", { className: "qmb-ui-toggle-wrapper__content" },
            React.createElement("span", { id: labelTextId, className: "qmb-ui-toggle-wrapper__label" }, label),
            helperText && React.createElement("span", { className: "qmb-ui-toggle-wrapper__helper-text" }, helperText))));
});
Toggle.displayName = 'Toggle';
